import React from 'react';
import { Hero } from '../components/Hero';
import { PropertyGrid } from '../components/PropertyGrid';
export function Home() {
  return <main data-id="element-103">
      <Hero data-id="element-104" />
      <PropertyGrid data-id="element-105" />

      {/* Value Prop Section */}
      <section className="py-32 px-6 md:px-12 bg-stone-50" data-id="element-106">
        <div className="max-w-4xl mx-auto text-center" data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-light text-charcoal-900 mb-8 leading-tight" data-id="element-108">
            Beyond the public market.
          </h2>
          <p className="text-xl text-charcoal-500 font-light leading-relaxed mb-12" data-id="element-109">
            Gain access to an exclusive portfolio of off-market properties and
            connect with dedicated private advisors who understand the nuances
            of luxury real estate acquisition.
          </p>
          <button className="px-8 py-4 bg-charcoal-900 text-white rounded-full hover:bg-charcoal-800 transition-colors font-medium text-lg" data-id="element-110">
            Request Private Access
          </button>
        </div>
      </section>
    </main>;
}